/** Wiki popup header colour: the module's page-header gradient. */
export const WIKI_POPUP_GRADIENT = 'bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600';
